export default {
  CLASSROOM: "classroom",
  KID: "kid",
};
